// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3c0cl","file":"styles_file__17N8w"};